import { render, staticRenderFns } from "./OpenActive.vue?vue&type=template&id=422fe40f&scoped=true&"
import script from "./OpenActive.vue?vue&type=script&lang=js&"
export * from "./OpenActive.vue?vue&type=script&lang=js&"
import style0 from "./OpenActive.vue?vue&type=style&index=0&id=422fe40f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422fe40f",
  null
  
)

export default component.exports